import { AVATAR_URL, SOCIAL_LINKS } from '@/config/links';
import { useLanguage } from '@/context/LanguageContext';
import {Facebook, Instagram, Youtube} from 'lucide-react';

function TikTokIcon({ className }: {className?: string;}) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.31 1.38V7.3s-1.88.09-3.25-1.48z" />
    </svg>);

}

const socials = [
{ key: 'instagram', href: SOCIAL_LINKS.instagram, icon: Instagram, label: 'Instagram' },
{ key: 'tiktok', href: SOCIAL_LINKS.tiktok, icon: TikTokIcon, label: 'TikTok' },
{ key: 'facebook', href: SOCIAL_LINKS.facebook, icon: Facebook, label: 'Facebook' },
{ key: 'youtube', href: SOCIAL_LINKS.youtube, icon: Youtube, label: 'YouTube' }];


function Hero() {
  const { t } = useLanguage();

  return (
    <section
      id="home"
      className="relative pt-4 pb-6 overflow-hidden">

      <div className="absolute inset-0">
        <img
          src="https://static.lumi.new/2d/2dfb8fcc933d4bb0132601408d9c27c4.png"
          alt="Van aménagé garé face à la montagne au coucher du soleil"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-[#2b1c12]/85 via-[#2b1c12]/85 to-[#2b1c12]" />
      </div>

      <div className="relative z-10 max-w-md mx-auto px-4 flex flex-col items-center text-center">
        <img
          src={AVATAR_URL}
          alt="Vitrine The Mimi Factory"
          className="w-20 h-20 sm:w-24 sm:h-24 mb-3 animate-fade-in-up object-contain"></img>

        <span className="inline-block px-3 py-1 rounded-full bg-amber-400/15 border border-amber-400/30 text-amber-300 text-xs font-medium tracking-wide mb-3 animate-fade-in-up">
          {t.hero.badge}
        </span>

        <h1 className="text-2xl sm:text-3xl font-bold text-amber-50 mb-3 tracking-tight animate-fade-in-up">
          {t.hero.title}
        </h1>

        <p className="text-amber-100/85 text-sm sm:text-base leading-relaxed mb-6 animate-fade-in-up">
          {t.hero.subtitle}
        </p>

        <a
          href="#contact"
          className="px-5 py-2.5 rounded-full bg-amber-500 text-[#2b1c12] font-semibold text-sm hover:bg-amber-400 transition-colors shadow-lg shadow-amber-900/30 mb-4 animate-fade-in-up">

          {t.hero.ctaPrimary}
        </a>

        <div className="flex items-center gap-3 animate-fade-in-up">
          {socials.map(({ key, href, icon: Icon, label }) =>
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-50/10 border border-amber-200/20 text-amber-100 hover:bg-amber-400 hover:text-[#2b1c12] hover:border-amber-400 transition-all duration-200">

              <Icon className="w-4 h-4" />
            </a>
          )}
        </div>
      </div>
    </section>);

}

export default Hero;